import useWalletCurrency from '~/client/hooks/currency/useWalletCurrency';
import useGameContext from '../context/Game/useGameContext';
import sendEventToUmami from '@/client/helpers/trackEvent/sendEventToUmami';
import getEventData from '@/client/helpers/trackEvent/umamiEvents/getEventData';

const useLaunchGameEvents = () => {
  const { game, isFunMode, inGameCurrency } = useGameContext();
  const providerName = game?.menuItem?.[0]?.name;
  const currency = useWalletCurrency();

  const data = getEventData('launchGame');

  return () => {
    if (data === null) {
      return null;
    }

    return sendEventToUmami(
      {
        isFunMode,
        source: {
          page: data.page,
          slider: data.slider
            ? {
                name: data.slider.name,
                sliderTileIndex: data.slider.sliderTileIndex,
                screenVPos: data.slider.screenVPos,
              }
            : undefined,
          grid: data.grid
            ? {
                index: data.grid.index,
                page: data.grid.page,
              }
            : undefined,
        },
        gameId: game?.id,
        currency,
        inGameCurrency,
        gameCategory: game?.category?.handle,
        gameProvider: providerName,
      },
      'launchGame',
    );
  };
};

export default useLaunchGameEvents;
